import styled, { css } from 'styled-components';
import { ThemeProps } from '@/styles/global';

interface Pagination {
  disabledBack: boolean;
  disabledForward: boolean;
}

interface ContentWrapper {
  perPage: number;
}

export const SubTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 3.6rem 0 2rem;
  @media (max-width: 768px) {
    margin: 2rem 0 1.5rem;
  }
`;

export const SubTitle = styled.p`
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 2rem;
  margin: 0;
  @media (max-width: 768px) {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  & > *:not(:first-child) {
    margin-left: 1.5rem;
  }
  & > * {
    min-width: ${(props: ContentWrapper) => {
      return `calc(${100 / props.perPage}% - 1.5rem*${props.perPage - 1}/${
        props.perPage
      })`;
    }};
    max-width: ${(props: ContentWrapper) => {
      return `calc(${100 / props.perPage}% - 1.5rem*${props.perPage - 1}/${
        props.perPage
      })`;
    }};
  }
  @media (max-width: 660px) {
    & > * {
      max-width: 100%;
      width: 100%;
    }
  }
`;

export const Pagination = styled.div`
  & svg {
    cursor: pointer;
    path {
      fill: ${(props: Pagination & ThemeProps) => props.theme.softGreenColor};
    }
    &:first-child {
      ${(props: Pagination) =>
        props.disabledBack &&
        css`
          pointer-events: none;
          path {
            fill: ${(props: Pagination & ThemeProps) => props.theme.grayColor};
          }
        `}
      transform: rotate(180deg);
      margin-right: 2rem;
    }
    &:last-child {
      ${(props: Pagination) =>
        props.disabledForward &&
        css`
          pointer-events: none;
          path {
            fill: ${(props: Pagination & ThemeProps) => props.theme.grayColor};
          }
        `}
    }
  }
`;
